// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__oGLyb","filters_close":"FiltersBlock_filters_close__H3e-i"};